<template>
  <div>
    <app-header :sysco="sysco"></app-header>

    <div class="modal fade" id="HandlePosition" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("delete_warning")}}</h5>
          </div>
          <div class="modal-body">
            <p>{{caption("handle_abovecenter")}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hideModal" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>


    <div class="container-fluid">
      <span><button type="button" class="btn btn-info btn-sm my-2" @click="starttour">{{caption("tour_tour")}}</button></span>
      <div class="row">
        <div class="col-xl-4 col-sm-12">
          <div class="row mt-2" style="text-align: center">
            <h1 class="col-sm-12 display-5">{{form.windowName}}</h1>
            <div class="col-sm-12" style="text-align: center">
              <window-graph :type="form.windowType" :dir="form.windowOpenDir" :hinge="form.windowHinge" :handle="selectedHandle == null ? '' : selectedHandle.bmp" :Fb1="form.windowFb1" :Fb2="form.windowFb2" :Fh="form.windowFh" :A="form.windowA"
                            :W1="form.windowWeight1" :W2="form.windowWeight2" :dim="dimension" :scale="scale" :profile="form.profile" :config="1"></window-graph>
            </div>
          </div>
          <div class="row mt-2" style="text-align: center" v-if="(form.windowType != 50 && form.windowType != 55)">
            <div class="col-sm-12" style="text-align: center">
              <div v-if="selHandle != ''" style="text-align:center">
                <img v-if="form.windowOpenDir == 1" class="centered-and-cropped" :src="'/src/assets/R_' + selHandle + '.PNG'" height="160 " width="200">
                <img v-if="form.windowOpenDir == 2" class="centered-and-cropped" :src="'/src/assets/L_' + selHandle + '.PNG'" height="160 " width="200">
                <div class="mt-2"><h2>{{selectedHandle.ext}}<span v-if="(form.windowType == 31 && form.windowChrono == 50)"> (x2)</span></h2></div>
              </div>
            </div>
          </div>
        </div>


        <div class="col-xl-8 col-sm-12">
          <form @submit.prevent="checkHandlePosition">
            <v-tour v-if="language == 'Nederlands'" name="WindowEditTour" :steps="stepsNED" :callbacks="myCallbacks" :options="myOptionsNED"></v-tour>
            <v-tour v-else-if="language == 'Chinese'" name="WindowEditTour" :steps="stepsCHI" :callbacks="myCallbacks" :options="myOptionsCHI"></v-tour>
            <v-tour v-else-if="language == 'Portugues'" name="WindowEditTour" :steps="stepsPOR" :callbacks="myCallbacks" :options="myOptionsPOR"></v-tour>
            <v-tour v-else name="WindowEditTour" :steps="stepsENG" :callbacks="myCallbacks" :options="myOptionsENG"></v-tour>
            
            <!-- Window -->
            <div class="form-row" :style="tour == true ? 'z-index:-1; position:relative;' : ''">
              <h6 class="col-sm-12">{{caption("addwin_Window")}}</h6>
              <div class="form-group col-sm-6">
                <input type="text" :placeholder="caption('addwin_WindowName')" class="input form-control form-control-sm v-step-0" @input="$v.form.windowName.$touch()" v-model.trim="form.windowName" />
                <div v-if="$v.form.windowName.$dirty">
                  <div v-if="!$v.form.windowName.required" class="alert alert-danger mt-1" style="text-align: center"><strong>{{caption("addwin_Required")}}</strong></div>
                </div>
              </div>
              <div class="form-group col-sm-2" v-if="(form.windowType != 55)">
                <button type="button" class="btn btn-outline-secondary btn-sm btn-block v-step-1" @click="SetDirection()"><strong>{{direction}}</strong></button>
              </div>
              <div class="form-group col-sm-2">
                <button v-if="setpackaging == false" type="button" :class="form.windowBulk == false ? 'btn btn-outline-primary btn-sm btn-block v-step-2' : 'btn btn-danger btn-sm btn-block v-step-2'" @click="SetPackaging()"><strong>{{setOrBulk}}</strong></button>
              </div>
              <div v-if="setgroove == false" class="form-group col-sm-2">
                <button type="button" :class="setgroove == false ? 'btn btn-outline-secondary btn-sm btn-block v-step-3' : 'btn btn-outline-secondary btn-sm btn-block'" @click="SetGroove()"><strong>{{groove}}</strong></button>
              </div>
            </div>

            <div class="form-row" :style="tour == true ? 'z-index:-1; position:relative;' : ''">
              <div class="form-group col-sm-2">
                <div class="form-text mb-1">{{caption("addwin_Quantity")}}</div>
                <input type="number" placeholder="Quantity" class="input form-control form-control-sm v-step-4" min="1" max="9999" @input="$v.form.windowQuantity.$touch()" v-model.number="form.windowQuantity" />
                <div v-if="$v.form.windowQuantity.$dirty">
                  <div v-if="!$v.form.windowQuantity.required" class="alert alert-danger mt-1" style="text-align: center"><strong>{{caption("addwin_Required")}}</strong></div>
                </div>
              </div>
              <div class="form-group col-sm-4">
                <div class="form-text mb-1">{{caption("addwin_Color")}}</div>
                <select class="form-control form-control-sm v-step-5" v-model="form.windowColor">
                  <option v-for="c in color" v-bind:key="c.code" v-bind:value="c.code">{{ caption(c.desc) }}</option>
                </select>
              </div>
            </div>
            <!-- Window end -->


            <!-- Chrono -->
            <div class="form-row" :style="tour == true ? 'z-index:-1; position:relative;' : ''">
              <h6 class="col-sm-12">Chrono</h6>
              <div class="form-group col-md-4 col-sm-6">
                <div class="form-text mb-1">{{caption("addwin_Type")}}</div>
                <select class="form-control form-control-sm v-step-6" v-model="form.windowType" @change="setFb2(form.windowType)">
                  <option v-for="t in types" v-bind:key="t.typeId" v-bind:value="t.typeId">{{ caption(t.typeDesc) }}</option>
                </select>
              </div>
              <div class="form-group col-md-2 col-sm-6">
                <div class="form-text mb-1">Chrono</div>
                <select class="form-control form-control-sm v-step-7" v-model="form.windowChrono" @change="SetChrono()">
                  <option v-for="c in chrono" v-bind:key="c.chronoId" v-bind:value="c.chronoId">{{ c.chronoDesc }}</option>
                </select>
                <div v-if="ChronoError != null && ChronoError !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{ChronoError}}</strong></div>
              </div>


              <!-- Hinge -->
              <div class="form-group col-md-4 col-sm-6">
                <div class="form-text mb-1">{{caption("addwin_Hinge")}}</div>
                <select class="form-control form-control-sm mb-2 v-step-8" @change="changehinge()" v-model="form.windowHinge">
                  <option v-for="h in hinge" v-bind:key="h.hingeId" v-bind:value="h.hingeId">{{ caption(h.hingeDesc) }}</option>
                </select>
                <div v-if="HingeError != null && HingeError !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{HingeError}}</strong></div>
              </div>
            </div>


            <!-- Handles -->
            <div class="form-row" :style="tour == true ? 'z-index:-1; position:relative;' : ''" v-if="(form.windowType != 55 && form.windowType != 50)" >

              <div v-if="[1, 2, 3, 4, 6, 60, 7, 8, 21, 22, 23, 26, 27].includes(form.windowType)" class="form-group col-md-2 col-sm-6">
                <div class="form-text mb-1">
                  {{caption("addwin_HandleFilter")}}
                </div>
                <select class="form-control form-control-sm" v-model="Stype">
                  <option value=0>{{caption("addwin_All")}}</option>
                  <option v-if="sysco != 2" value=1>{{caption("addwin_Fork")}}</option>
                  <option value=2>{{caption("addwin_ForkS")}}</option>
                  <option value=3>{{caption("addwin_Lockcase")}}</option>
                </select>
              </div>

              <div class="form-group col-md-4 col-sm-6">
                <div class="form-text mb-1">{{caption("addwin_Handle")}}</div>
                <select class="form-control form-control-sm mb-2 v-step-9" @change="$v.form.windowHandleAN.$touch()" v-model="form.windowHandleAN">
                  <option v-for="h in handles" v-bind:key="h.id" v-bind:value="h.anr">{{ h.ext != 'NONE' && h.ext != 'ENVI NO HANDLE' ? h.ext : caption("addwin_NoHandle") }}</option>
                </select>

                <div v-if="$v.form.windowHandleAN.$dirty">
                  <div v-if="!$v.form.windowHandleAN.required" class="alert alert-danger mt-1" style="text-align: center"><strong>{{caption("addwin_Required")}}</strong></div>
                  <div v-if="HandleError != null && HandleError !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{HandleError}}</strong></div>
                </div>
              </div>


              <div class="form-group col-md-2 col-sm-6" v-if="(selectedHandle != null && selectedHandle.vrk == 1 && sethandleplate == false) || tour == true">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_HandleReinforcement")}}
                </div>
                <button type="button" :class="form.handleReinforcement == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-10' : 'btn btn-primary btn-sm btn-block v-step-10'" @click="SetHandleReinforcement()"><strong>{{handlereinforcement}}</strong></button>
              </div>
              <div class="form-group col-md-2 col-sm-6" v-if="form.windowChrono == 40 || tour == true">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_DrillingProtection")}}
                </div>
                <button type="button" :class="form.drillingProtection == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-11' : 'btn btn-primary btn-sm btn-block v-step-11'" @click="SetDrillingProtection()"><strong>{{drillingprotection}}</strong></button>
              </div>
              <!-- Disable button Block90
              <div class="form-group col-md-2 col-sm-6" v-if="(selectedHandle != null && selectedHandle.vrk == 1 && setblock90 == false && (form.windowType == 7 || form.windowType == 8)) || tour==true">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_Handle90Block")}}
                </div>
                 <button type="button" :class="form.handle90Block == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-11' : 'btn btn-primary btn-sm btn-block v-step-11'" @click="SetHandle90Block()"><strong>{{handle90block}}</strong></button>
              </div>
              -->
            </div>


            <!-- Motors -->
            <div class="form-row" :style="tour == true ? 'z-index:-1; position:relative;' : ''" v-if="(form.windowType == 55 || form.windowType == 50)" >
              <div class="form-group col-md-4 col-sm-6">
                <div class="form-text mb-1">{{caption("addwin_Motor")}}</div>
                <select class="form-control form-control-sm mb-2 v-step-10" v-model="form.windowMotorAN">
                  <option v-for="m in motor" v-bind:key="m.anr" v-bind:value="m.anr">{{ m.ext }}</option>
                </select>
              </div>
            </div>


            <!-- Profile -->
            <div class="form-row" :style="tour == true ? 'z-index:-1; position:relative;' : ''">
              
              <div class="form-group col-md-3 col-sm-6" v-if="form.windowType == 30 || form.windowType == 31 ||  tour==true">
                <div class="form-text mb-1">{{caption("addwin_Profile")}}</div>
                <select class="form-control form-control-sm v-step-12" v-model="form.profile">
                  <option v-for="p in profiles" v-bind:key="p.id" v-bind:value="p.anr">{{ p.anr }}</option>
                </select>
              </div>

              <div class="form-group col-md-3 col-sm-6" v-if="form.windowType == 50 || form.windowType == 55">
                <div class="form-text mb-1">{{caption("addwin_Profile")}}</div>
                <select class="form-control form-control-sm v-step-12" v-model="form.profile">
                  <option v-for="ip in invisitopprofiles" v-bind:key="ip.prf" v-bind:value="ip.prf">{{ ip.prf }}</option>
                </select>
              </div>

            </div>


            <!-- Dimentions -->
            <div class="form-row" :style="tour == true ? 'z-index:-1; position:relative;' : ''">
              <div class="col-sm-12"><h6>{{caption("addwin_Dimensions")}}</h6></div>
              <div class="form-group col-md-2 col-sm-6">
                <div class="form-text mb-1">{{caption("addwin_Fb1")}}</div>
                <input type="number" class="input form-control form-control-sm v-step-13" min="1" max="2400" @input="$v.form.windowFb1.$touch()" v-model.number.lazy="form.windowFb1" />
                <div v-if="$v.form.windowFb1.$dirty">
                  <div v-if="!$v.form.windowFb1.required" class="alert alert-danger mt-1" style="text-align: center"><strong>{{caption("addwin_Required")}}</strong></div>
                </div>
                <div v-if="Fb1Error != null && Fb1Error !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{Fb1Error}}</strong></div>
              </div>

              <div class="form-group col-md-2 col-sm-6" v-if="(showFb2 || tour == true) && (form.windowType != 55 && form.windowType != 50)">
                <div class="form-text mb-1">{{caption("addwin_Fb2")}}</div>
                <input type="number" class="input form-control form-control-sm v-step-14" min="0" max="2400" @input="$v.form.windowFb2.$touch()" v-model.number.lazy="form.windowFb2" />
                <div v-if="$v.form.windowFb2.$dirty">
                  <div v-if="!$v.form.windowFb2.required" class="alert alert-danger mt-1" style="text-align: center"><strong>{{caption("addwin_Required")}}</strong></div>
                </div>
                <div v-if="Fb2Error != null && Fb2Error !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{Fb2Error}}</strong></div>
              </div>

              <div v-if="showFb2 == false  || form.windowType == 55 || form.windowType == 50" class="form-group col-md-2 col-sm-12"></div>

              <div class="form-group col-md-2 col-sm-6">
                <div class="form-text mb-1">{{caption("addwin_Fh")}}</div>
                <input type="number" class="input form-control form-control-sm v-step-15" min="1" max="2800" @input="$v.form.windowFh.$touch()" @blur="setA(form.windowType)" v-model.number.lazy="form.windowFh" />
                <div v-if="$v.form.windowFh.$dirty">
                  <div v-if="!$v.form.windowFh.required" class="alert alert-danger mt-1" style="text-align: center"><strong>{{caption("addwin_Required")}}</strong></div>
                </div>
                <div v-if="FhError != null && FhError !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{FhError}}</strong></div>

              </div>
              <div class="form-group col-md-2 col-sm-6" v-if="form.windowType != 55">
                <div class="form-text mb-1">{{caption("addwin_A")}}</div>
                <input class="input form-control form-control-sm v-step-16" min="1.0" max="2400.0" v-model="form.windowA" />
                <div v-if="AError != null && AError !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{AError}}</strong></div>
              </div>

              <div class="form-group col-md-2 col-sm-6">
                <div class="form-text mb-1">{{weightLabel}}</div>
                <input type="number" class="input form-control form-control-sm v-step-17" min="1" max="200" @input="$v.form.windowWeight1.$touch()" v-model.number="form.windowWeight1" />
                <div v-if="$v.form.windowWeight1.$dirty">
                  <div v-if="!$v.form.windowWeight1.required" class="alert alert-danger mt-1" style="text-align: center"><strong>{{caption("addwin_Required")}}</strong></div>
                </div>
                <div v-if="W1Error != null && W1Error !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{W1Error}}</strong></div>
              </div>
              <div class="form-group col-md-2 col-sm-6" v-if="(showFb2 || tour == true) && (form.windowType != 55 && form.windowType != 50)">
                <div class="form-text mb-1">{{caption("addwin_Weight")}}2(kg)</div>
                <input type="number" class="input form-control form-control-sm v-step-18" min="1" max="200" @input="$v.form.windowWeight2.$touch()" v-model.number="form.windowWeight2" />
                <div v-if="$v.form.windowWeight2.$dirty">
                  <div v-if="!$v.form.windowWeight2.required" class="alert alert-danger mt-1" style="text-align: center"><strong>{{caption("addwin_Required")}}</strong></div>
                </div>
                <div v-if="W2Error != null && W2Error !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{W2Error}}</strong></div>
              </div>
            </div>


            <!-- Options -->
            <div class="form-row" :style="tour == true ? 'z-index:-1; position:relative;' : ''">
              <div class="col-sm-12"><h6>{{caption("addwin_Options")}}</h6></div>

              <div class="form-group col-xl-2 col-lg-6" v-if="(form.windowType != 55 && form.windowType != 50)">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_Vent")}}
                </div>
                <button type="button" :class="form.windowK12 == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-19' : 'btn btn-primary btn-sm btn-block v-step-19'" @click="SetNightvent()"><strong>{{nightvent}}</strong></button>
                <div v-if="VentError != null && VentError !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{VentError}}</strong></div>
              </div>

              <div class="form-group col-xl-2 col-lg-6" v-if="((setfcmagnet == false) || tour==true) && (form.windowType != 55 && form.windowType != 50)">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_Magnet")}}
                </div>
                <button type="button" :class="form.windowMAC == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-20' : 'btn btn-primary btn-sm btn-block v-step-20'" @click="SetMagnet()"><strong>{{magnet}}</strong></button>
                <div v-if="MagnetError != null && MagnetError !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{MagnetError}}</strong></div>
              </div>

              <div class="form-group col-xl-2 col-lg-6" v-if="(form.windowType != 55 && form.windowType != 50)">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_Stay")}}
                </div>
                <button type="button" :class="form.windowRAB == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-21' : 'btn btn-primary btn-sm btn-block v-step-21'" @click="SetStay()"><strong>{{stay}}</strong></button>
              </div>

              <div class="form-group col-xl-2 col-lg-6" v-if="(form.windowType != 55 && form.windowType != 50)">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_Snapper")}}
                </div>
                <button type="button" :class="form.windowSNP == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-22' : 'btn btn-primary btn-sm btn-block v-step-22'" @click="SetSnapper()"><strong>{{snapper}}</strong></button>
                <div v-if="SnapperError != null && SnapperError !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{SnapperError}}</strong></div>
              </div>

              <div class="form-group col-xl-2 col-lg-6" v-if="(form.windowType == 50 || form.windowType == 55)">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_LinkArm")}}
                </div>
                <button type="button" :class="form.windowXVS == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-23' : 'btn btn-primary btn-sm btn-block v-step-23'" @click="SetLinkArm()"><strong>{{linkarm}}</strong></button>
                <div v-if="XVSError != null && XVSError !=''" class="alert alert-danger mt-1" style="text-align: center"><strong>{{XVSError}}</strong></div>
              </div>

            </div>
        
            <div v-if="(form.windowType != 55 && form.windowType != 50)" class="form-row" :style="tour == true ? 'z-index:-1; position:relative;' : ''">
              <div class="form-group col-xl-2 col-lg-6" v-if="(showFb2 && setfcscrew == false && !(form.windowType == 31 && form.windowChrono == 50)) || tour==true">
                <div class="form-text mb-1">{{caption("addwin_ScrewLength")}}</div>
                <select class="form-control form-control-sm v-step-23" v-model="form.windowScrew">
                  <option v-for="s in screw" v-bind:key="s" v-bind:value="s">{{ s }}</option>
                </select>
              </div>
              <div class="form-group col-xl-2 col-lg-6" v-if="(showFb2 && setfcprofile == false && !(form.windowType == 31 && form.windowChrono == 50)) || tour==true">
                <div class="form-text mb-1">{{caption("addwin_ProfileDepth")}}</div>
                <input type="number" class="input form-control form-control-sm v-step-24" min="30" :max="form.windowChrono==10 || form.windowChrono==20 ? 53 : 60" @input="$v.form.windowDepth.$touch()" v-model.number="form.windowDepth" />
                <div v-if="$v.form.windowDepth.$dirty">
                  <small class="form-text text-danger" v-if="!$v.form.windowDepth.required">{{caption("addwin_Required")}}</small>
                </div>
              </div>
              <div class="form-group col-xl-2 col-lg-6" v-if="(showFb2 && !(form.windowType == 4 && form.windowChrono == 10) && form.windowType != 22 && form.windowType != 27 && form.windowType != 31 && (form.windowChrono == 10 || form.windowChrono == 20) && setfccentral == false) || tour==true">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_FCLockcase")}}
                </div>
                <button type="button" :class="form.fcLockcase == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-25' : 'btn btn-primary btn-sm btn-block v-step-25'" @click="SetFCLockcase()"><strong>{{fclockcase}}</strong></button>
              </div>
              <div class="form-group col-xl-2 col-lg-6" v-if="(showFb2 && form.windowType != 22 && form.windowType != 27 && form.windowType != 31 && (form.windowChrono == 10 || form.windowChrono == 20) && form.fcLockcase == 0 && setfcadjkeeps == false) || tour==true">
                <div class="form-text mb-1" style="text-align: center">
                  {{caption("addwin_AdjustableFCKeeps")}}
                </div>
                <button type="button" :class="form.adjustableFCKeeps == 0 ? 'btn btn-outline-secondary btn-sm btn-block v-step-26' : 'btn btn-primary btn-sm btn-block v-step-26'" @click="SetAdjustableFCKeeps()"><strong>{{adjustablefckeeps}}</strong></button>
              </div>
            </div>
            <!-- Options end -->


            <div class="form-row">
              <div class="form-group col-md-6">
                <button class="btn btn-sm btn-primary v-step-27" type="submit">{{caption("Submit")}}</button>
                <button class="btn btn-sm btn-secondary v-step-28" type="button" @click="cancel">{{caption("Cancel")}}</button>
              </div>
            </div>
          </form>
          <div>
            <div v-if="Error != ''" class="alert alert-danger" role="alert"><strong>{{Error}}</strong></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AppHeader from "../intro/AppHeader";
  import WindowGraph from "./WindowGraph";
  import store from "../../ClientApp/store";
  import { required, minValue, maxValue } from "vuelidate/lib/validators";
  import { mapActions, mapGetters } from "vuex";
  import steps from '../../ClientApp/helpers/windowedit-steps';

  export default {
    data: function () {
      return {
        dimension: true,
        scale: 11,
        setOrBulk: this.caption("Set"),
        groove: "14-18",
        direction: this.caption("addwin_Right"),
        nightvent: this.caption("addwin_No"),
        magnet: this.caption("addwin_No"),
        stay: this.caption("addwin_No"),
        snapper: this.caption("addwin_No"),
        fclockcase: this.caption("addwin_No"),
        handlereinforcement: this.caption("addwin_No"),
        drillingprotection: this.caption("addwin_No"),
        adjustablefckeeps: this.caption("addwin_No"),
        handle90block: this.caption("addwin_No"),
        stype: this.caption("addwin_No"),
        linkarm: this.caption("addwin_No"),
        Stype: 0,
        form: {
          windowName: "",
          windowType: 1,
          windowQuantity: 1,
          windowChrono: 10,
          windowHinge: 1,
          windowHandle: 1,
          windowFb1: 1000,
          windowFb2: 1000,
          windowFh: 2000,
          windowA: 1000.0,
          windowWeight1: 10,
          windowWeight2: 10,
          windowColor: "CN",
          windowScrew: "6",
          windowDepth: 30,
          windowBulk: false,
          windowK12: false,
          windowMAC: false,
          windowRAB: 0,
          windowSNP: false,
          windowXVS: false,
          windowOpenDir: 1,
          windowGroove: 14,
          windowHandleAN: null,
          windowMotorAN: null,
          fcLockcase: false,
          handleReinforcement: false,
          drillingProtection: false,
          adjustableFCKeeps: false,
          handle90Block: false,
          windowSType: 0,
          profile: null
        },
        showFb2: false,
        showWeight2: false,
        weightLabel: this.caption("addwin_Weight") + "(kg)",
        error: null,
        tour: false,
        myCallbacks: {
          onStart: this.myTourStart,
          onStop: this.myTourStop
        },
        myOptionsNED: {
          labels: {
            buttonSkip: 'Verlaat tour',
            buttonPrevious: 'Vorige',
            buttonNext: 'Volgende',
            buttonStop: 'Einde'
          }
        },
        myOptionsENG: {
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Finish'
          }
        },
        myOptionsCHI: {
          labels: {
            buttonSkip: '跳过演示说明',
            buttonPrevious: '上一步',
            buttonNext: '下一步',
            buttonStop: '演示结束'
          }
        },
        myOptionsPOR: {
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Finish'
          }
        },
        stepsENG: steps.stepsENG,
        stepsCHI: steps.stepsCHI,
        stepsNED: steps.stepsNED,
        stepsPOR: steps.stepsPOR,
      };
    },
    validations: {
      form: {
        windowName: {
          required
        },
        windowType: {
          required
        },
        windowQuantity: {
          required
        },
        windowChrono: {
          required
        },
        windowHinge: {
          required
        },
        windowHandle: {
          required
        },
        windowFb1: {
          minValue: 1,
          required
        },
        windowFb2: {
          minValue: 0,
          required
        },
        windowFh: {
          minValue: 1,
          required
        },
        windowA: {
          minValue: 1.0,
          required
        },
        windowWeight1: {
          minValue: 1,
          required
        },
        windowWeight2: {
          minValue: 1,
          required
        },
        windowColor: {
          required
        },
        windowScrew: {
          required
        },
        windowDepth: {
          minValue: 30,
          maxValue: 60,
          required
        },
        windowHandleAN: {
          required
        },
        // windowMotorAN: {
        //   required
        // },
        // windowInvisitopProfile: {
        //   required
        // }
      }
    },
    components: {
      AppHeader,
      WindowGraph
    },
    computed: {
      window() {
        if (this.wid != 0)
          return this.$store.getters.getWindowById(this.wid);
      },
      wid() {
        return this.$route.params.id;
      },
      proj() {
        return this.$store.getters.getCurrentProject;
      },
      types() {
        return this.$store.getters.getTypes;
      },
      profiles() {
        return this.$store.getters.getProfiles;
      },
      invisitopprofiles() {
        return this.$store.getters.getInvisitopProfilesForWindow(this.form.windowHinge, this.form.windowChrono);
      },
      chrono() {
        return this.$store.getters.getChrono;
      },
      hinge() {
        return this.$store.getters.getHinge;
      },
      handles() {
        if (this.form.windowType == 1 || this.form.windowType == 2 || this.form.windowType == 21 || this.form.windowType == 22) {
          this.filteredHandles = this.$store.state.handles
            .filter(t => t.drk === 1)
            .filter(t => t.rct == this.form.windowOpenDir || t.rct == null)
            .filter(c => c.col === this.form.windowColor || c.col == null)
            .filter(d => (this.form.windowChrono == 40 || this.form.windowChrono == 50) ? d.cyl == 1 : d)
            .filter(e => (this.Stype == 0) ? e.sty == 0 || e.sty == 1 || e.sty == null : (this.Stype == 1) ? e.sty == 0 : (this.Stype == 2) ? e.sty == 1 : (this.Stype == 3) ? e.sty == null : e.sty == 0 || e.sty == 1 || e.sty == null);
        }
        if (this.form.windowType == 3 || this.form.windowType == 4 || this.form.windowType == 23) {
          this.filteredHandles = this.$store.state.handles
            .filter(t => t.kdr === 1)
            .filter(t => t.rct == this.form.windowOpenDir || t.rct == null)
            .filter(c => c.col === this.form.windowColor || c.col == null)
            .filter(d => (this.form.windowChrono == 40 || this.form.windowChrono == 50) ? d.cyl == 1 : d)
            .filter(e => (this.Stype == 0) ? e.sty == 0 || e.sty == 1 || e.sty == null : (this.Stype == 1) ? e.sty == 0 : (this.Stype == 2) ? e.sty == 1 : (this.Stype == 3) ? e.sty == null : e.sty == 0 || e.sty == 1 || e.sty == null);
        }
        if (this.form.windowType == 6 || this.form.windowType == 60 || this.form.windowType == 7 || this.form.windowType == 8 || this.form.windowType == 26 || this.form.windowType == 27) {
          this.filteredHandles = this.$store.state.handles
            .filter(t => t.drr === 1)
            .filter(t => t.rct == this.form.windowOpenDir || t.rct == null)
            .filter(c => c.col === this.form.windowColor || c.col == null)
            .filter(d => (this.form.windowChrono == 40 || this.form.windowChrono == 50) ? d.cyl == 1 : d)
            .filter(e => (this.Stype == 0) ? e.sty == 0 || e.sty == 1 || e.sty == null : (this.Stype == 1) ? e.sty == 0 : (this.Stype == 2) ? e.sty == 1 : (this.Stype == 3) ? e.sty == null : e.sty == 0 || e.sty == 1 || e.sty == null);
        }
        if (this.form.windowType == 30 || this.form.windowType == 31) {
          this.filteredHandles = this.$store.state.handles
            .filter(t => t.oo === 1)
            .filter(t => t.rct == this.form.windowOpenDir || t.rct == null)
            .filter(c => c.col === this.form.windowColor || c.col == null)
            .filter(d => (this.form.windowChrono == 40 || this.form.windowChrono == 50) ? d.cyl == 1 : d)
        }      
        var flag = 0;



        this.filteredHandles.forEach(element => {
          if (element.anr == this.form.windowHandleAN) {
            flag = 1;
          }
        })
        if (flag == 0) this.form.windowHandleAN = null;

        return this.filteredHandles;
      },
      motor() {
        return this.$store.getters.getMotors;
      },
      color() {
        return this.$store.getters.getColor;
      },
      screw() {
        return this.$store.getters.getScrew;
      },
      selectedHandle() {
        return this.$store.getters.getHandleByAN(this.form.windowHandleAN);
      },
      selHandle() {
        var sh = this.$store.getters.getHandleByAN(this.form.windowHandleAN);
        if (sh != null)
          return sh.bmp;
        else
          return '';
      },
      Error() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = this.caption("addwin_Error");
        return msg;
      },
      Fb1Error() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.fb1Error;
        return msg;
      },
      Fb2Error() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.fb2Error;
        return msg;
      },
      FhError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.fhError;
        return msg;
      },
      AError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.aError;
        return msg;
      },
      W1Error() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.w1Error;
        return msg;
      },
      W2Error() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.w2Error;
        return msg;
      },
      HingeError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.hingeError;
        return msg;
      },
      HandleError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.handleError;
        return msg;
      },
      MotorError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.motorError;
        return msg;
      },
      VentError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.ventError;
        return msg;
      },
      MagnetError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.magnetError;
        return msg;
      },
      SnapperError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.snapperError;
        return msg;
      },
      ChronoError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.chronoError;
        return msg;
      },
      XVSError() {
        var errormsg = this.$store.state.windowCreateResponse;
        var msg = "";
        if (errormsg != null && errormsg.err == 1)
          msg = errormsg.xvserror;
        return msg;
      },
      sysco() {
        return this.$store.getters.getAuth.systemCompany;
      },
      setgroove() {
        return this.$store.getters.getAuth.setGroove;
      },
      getgroove() {
        return this.$store.getters.getAuth.groove;
      },
      setpackaging() {
        return this.$store.getters.getAuth.setPackaging;
      },
      getpackaging() {
        return this.$store.getters.getAuth.packaging;
      },
      sethandleplate() {
        return this.$store.getters.getAuth.setHandlePlate;
      },
      gethandleplate() {
        return this.$store.getters.getAuth.handlePlate;
      },
      setblock90() {
        return this.$store.getters.getAuth.setBlock90;
      },
      getblock90() {
        return this.$store.getters.getAuth.block90;
      },
      // setdrillingprotection() {
      //   return this.$store.getters.getAuth.setDrillingProtection;
      // },
      // getdrillingprotection() {
      //   return this.$store.getters.getAuth.drillingProtection;
      // },
      setfcscrew() {
        return this.$store.getters.getAuth.setFCScrew;
      },
      getfcscrew() {
        return this.$store.getters.getAuth.fcScrew;
      },
      setfcprofile() {
        return this.$store.getters.getAuth.setFCProfile;
      },
      getfcprofile() {
        return this.$store.getters.getAuth.fcProfile;
      },
      setfccentral() {
        return this.$store.getters.getAuth.setFCCentral;
      },
      getfccentral() {
        return this.$store.getters.getAuth.fcCentral;
      },
      setfcadjkeeps() {
        return this.$store.getters.getAuth.setFCAdjKeeps;
      },
      getfcadjkeeps() {
        return this.$store.getters.getAuth.fcAdjKeeps;
      },
      setfcmagnet() {
        return this.$store.getters.getAuth.setFCMagnet;
      },
      getfcmagnet() {
        return this.$store.getters.getAuth.fcMagnet;
      },
      language() {
        return this.$store.state.auth.language;
      },
    },
    mounted() {
      if (this.wid != 0) {
        this.form.windowName = this.window.name;
        this.form.windowType = this.window.windowType;
        this.form.windowQuantity = this.window.quantity;
        this.form.windowChrono = this.window.chrono;
        this.form.windowHinge = this.window.hingeType;
        this.form.windowHandle = this.window.handleType;
        this.form.windowFb1 = this.window.fb1;
        this.form.windowFb2 = this.window.fb2;
        if (this.window.fb2 == 0) {
          this.form.windowFb2 = 1000;
          this.form.windowWeight2 = 10
          this.showFb2 = false;
          this.showWeight2 = false;
          this.widthLabel = this.caption("addwin_Fb");
          this.weightLabel = this.caption("addwin_Weight") + "(kg)";
        }
        if (this.window.fb2 != 0) {
          this.showFb2 = true;
          this.showWeight2 = true;
          this.widthLabel = this.caption("addwin_Fb1");
          this.weightLabel = this.caption("addwin_Weight") + "(kg)"
        }
        this.form.windowFh = this.window.fh;
        this.form.windowA = this.window.a;
        this.form.windowWeight1 = this.window.weight1;
        this.form.windowWeight2 = this.window.weight2;
        this.form.windowColor = this.window.colorCode;
        this.form.windowScrew = this.window.screwLength;
        this.form.windowDepth = this.window.profileDepth;
        this.form.windowBulk = this.window.bulk;
        this.form.windowK12 = this.window.k12;
        this.form.windowMAC = this.window.mac;
        this.form.windowRAB = this.window.rab;
        this.form.windowSNP = this.window.snp;
        this.form.windowXVS = this.window.xvs;
        this.form.windowOpenDir = this.window.openDir;
        this.form.windowGroove = this.window.groove;
        this.form.windowHandleAN = this.window.handleAN;
        this.form.windowMotorAN = this.window.motorAN;
        this.form.fcLockcase = this.window.fcLockcase;
        this.form.handleReinforcement = this.window.handleReinforcement;
        this.form.drillingProtection = this.window.drillingProtection;
        this.form.adjustableFCKeeps = this.window.adjustableFCKeeps;
        this.form.handle90Block = this.window.handle90Block;
        this.setOrBulk = (this.form.windowBulk != true ? this.caption("Set") : this.caption("Bulk"));
        this.groove = (this.form.windowGroove == 14 ? "14-18" : "10-14");
        this.direction = (this.form.windowOpenDir == 1 ? this.caption("addwin_Right") : this.caption("addwin_Left"));
        this.nightvent = (this.form.windowK12 == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes"));
        this.magnet = (this.form.windowMAC == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes"));
        this.linkarm = (this.form.windowXVS == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes"));
        if (this.form.windowHinge != 5) {
          this.stay = this.form.windowRAB == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes");
        }
        if (this.form.windowHinge == 5) {
          if (this.form.windowRAB == 0) this.stay = this.caption("addwin_No");
          if (this.form.windowRAB == 1) this.stay = "= 90°";
          if (this.form.windowRAB == 2) this.stay = "< 90°";
        }
        this.snapper = (this.form.windowSNP == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes"));
        this.fclockcase = (this.form.fcLockcase == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes"));
        this.handlereinforcement = (this.form.handleReinforcement == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes"));
        this.drillingprotection = (this.form.drillingProtection == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes"));
        this.adjustablefckeeps = (this.form.adjustableFCKeeps == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes"));
        this.handle90block = (this.form.handle90Block == 0 ? this.caption("addwin_No") : this.caption("addwin_Yes"));
        this.form.profile = this.window.profile;
      }
      this.$store.commit("resetError")
    },
    methods: {
      ...mapActions(['windowedit', 'windowpost', 'getwindows']),

      setFb2(wt) {
        if (wt == 2 || wt == 4 || wt == 60 || wt == 22 || wt == 24 || wt == 27 || wt == 31) {
          this.showFb2 = true;
          this.showWeight2 = true;
          if (this.form.weight2 == 0) this.form.weight2 = 1;
          this.weightLabel = this.caption("addwin_Weight") + "(kg)";
          this.form.windowMotorAN = "";
        }
        else {
          this.showFb2 = false;
          this.showWeight2 = false;
          if (this.form.weight2 != 0) this.form.weight2 = 0;
          this.weightLabel = this.caption("addwin_Weight") + "(kg)";
        }
        if(wt == 4 && this.form.windowChrono == 10)
        {
          this.form.fcLockcase = 1;
          this.fclockcase = this.caption("addwin_Yes");
          this.form.windowMotorAN = "";
        }
        if(wt == 50 || wt == 55)
        {
          this.form.windowA = this.form.windowFh / 2;

          this.form.windowSNP = 0;
          this.snapper = this.caption("addwin_No");

          this.form.windowRAB = 0;
          this.stay = this.caption("addwin_No");

          this.form.windowK12 = 0;
          this.nightvent = this.caption("addwin_No");

          this.form.windowMAC = 0;
          this.magnet = this.caption("addwin_No");

          this.form.windowHandle = 0;
          this.form.windowHandleAN = 'ENVI NO HANDLE';

          this.form.windowFb2 = 0;
          this.form.windowWeight2 = 0;
          this.showFb2 = false;
          this.showWeight2 = false;

          if(this.motor.length > 0){
            this.form.windowMotorAN = this.motor[0].ext;
          }

          if(this.invisitopprofiles.length > 0){
            this.form.profile = this.invisitopprofiles[0].prf;
          }
        }
        if(wt != 55){
          this.form.windowMotorAN = "";
          this.form.profile = "";
        }
      },
      setA(wt) {
        if (wt != 8)
          this.form.windowA = this.form.windowFh / 2;
        else
          this.form.windowA = this.form.windowFb1 / 2;
      },

      SetPackaging() {
        this.form.windowBulk = !this.form.windowBulk;
        if (this.form.windowBulk == true) { this.setOrBulk = this.caption("Bulk"); }
        else { this.setOrBulk = this.caption("Set"); }
      },

      SetGroove() {
        if (this.form.windowGroove == 14) {
          this.form.windowGroove = 10;
          this.groove = "10-14";
        }
        else {
          this.form.windowGroove = 14;
          this.groove = "14-18";
        }
      },
      SetDirection() {
        if (this.form.windowOpenDir == 1) {
          this.form.windowOpenDir = 2;
          this.direction = this.caption("addwin_Left");
        }
        else {
          this.form.windowOpenDir = 1;
          this.direction = this.caption("addwin_Right");
        }
      },
      SetNightvent() {
        if (this.form.windowK12 == 1) {
          this.form.windowK12 = 0;
          this.nightvent = this.caption("addwin_No");
        }
        else {
          this.form.windowK12 = 1;
          this.nightvent = this.caption("addwin_Yes");
        }
      },

      SetMagnet() {
        if (this.form.windowMAC == 1) {
          this.form.windowMAC = 0;
          this.magnet = this.caption("addwin_No");
        }
        else {
          this.form.windowMAC = 1;
          this.magnet = this.caption("addwin_Yes");
        }
      },

      SetStay() {
        if (this.form.windowHinge != 5) {
          if (this.form.windowRAB == 1) {
            this.form.windowRAB = 0;
            this.stay = this.caption("addwin_No");
          }
          else {
            this.form.windowRAB = 1;
            this.stay = this.caption("addwin_Yes");
          }
        }
        else if (this.form.windowHinge == 5 && this.form.windowType != 30 && this.form.windowType != 31) {
          var rab = this.form.windowRAB;
          switch (rab) {
            case 1:
              this.form.windowRAB = 2;
              this.stay = "< 90°";
              break;
            case 2:
              this.form.windowRAB = 0;
              this.stay = this.caption("addwin_No");
              break;
            case 0:
              this.form.windowRAB = 1;
              this.stay = "= 90°";
              break;
            default:
          }
        }
        else if(this.form.windowHinge == 5 && (this.form.windowType == 30 || this.form.windowType == 31))
        {
          if (this.form.windowRAB == 1) {
            this.form.windowRAB = 0;
            this.stay = this.caption("addwin_No");
          }
          else {
            this.form.windowRAB = 1;
            this.stay = this.caption("addwin_Yes");
          }
        }
      },

      SetSnapper() {
        if (this.form.windowSNP == 1) {
          this.form.windowSNP = 0;
          this.snapper = this.caption("addwin_No");
        }
        else {
          this.form.windowSNP = 1;
          this.snapper = this.caption("addwin_Yes");
        }
      },
      SetFCLockcase() {
        if (this.form.fcLockcase == 1) {
          this.form.fcLockcase = 0;
          this.fclockcase = this.caption("addwin_No");
        }
        else {
          this.form.fcLockcase = 1;
          this.fclockcase = this.caption("addwin_Yes");
        }
      },
      SetLinkArm(){
        if (this.form.windowXVS == 1) {
          this.form.windowXVS = 0;
          this.linkarm = this.caption("addwin_No");
        }
        else {
          this.form.windowXVS = 1;
          this.linkarm = this.caption("addwin_Yes");
        }
      },
      SetChrono(){
        if(this.form.windowChrono != 40){
          this.form.drillingProtection = 0;
          this.drillingprotection = this.caption("addwin_No");
        }
        if(this.form.windowChrono == 10 && this.form.windowType == 4)
        {
          this.form.fcLockcase = 1;
          this.fclockcase = this.caption("addwin_Yes");
        }
      },
      SetHandleReinforcement() {
        if (this.form.handleReinforcement == 1) {
          this.form.handleReinforcement = 0;
          this.handlereinforcement = this.caption("addwin_No");
        }
        else {
          this.form.handleReinforcement = 1;
          this.handlereinforcement = this.caption("addwin_Yes");
        }
      },
      SetDrillingProtection() {
        if (this.form.drillingProtection == 1) {
          this.form.drillingProtection = 0;
          this.drillingprotection = this.caption("addwin_No");
        }
        else {
          this.form.drillingProtection = 1;
          this.drillingprotection = this.caption("addwin_Yes");
        }
      },
      SetAdjustableFCKeeps() {
        if (this.form.adjustableFCKeeps == 1) {
          this.form.adjustableFCKeeps = 0;
          this.adjustablefckeeps = this.caption("addwin_No");
        }
        else {
          this.form.adjustableFCKeeps = 1;
          this.adjustablefckeeps = this.caption("addwin_Yes");
        }
      },
      SetHandle90Block() {
        if (this.form.handle90Block == 1) {
          this.form.handle90Block = 0;
          this.handle90block = this.caption("addwin_No");
        }
        else {
          this.form.handle90Block = 1;
          this.handle90block = this.caption("addwin_Yes");
        }
      },      
      checkHandlePosition() {
        if (this.form.windowA > this.form.windowFh / 2 && this.form.windowType != 8)
          $('#HandlePosition').modal('show');
        else
          this.edit();
      },
      hideModal: function () {
        $('#HandlePosition').modal('hide');
        this.edit();
      },
      isFCLockCaseAvailable: function () {
        return (showFb2 && !(form.windowType == 4 && form.windowChrono == 10) && form.windowType != 22 && form.windowType != 27 && form.windowType != 31 && (form.windowChrono == 10 || form.windowChrono == 20) && setfccentral == false);
      },
      edit() {
        this.$v.form.$touch();
        if (this.$v.form.$error) return;
        if (this.form.windowType == 1 || this.form.windowType == 3 || this.form.windowType == 6 || this.form.windowType == 7 || this.form.windowType == 8 || 
            this.form.WindowType == 16 || this.form.WindowType == 46 ||
            this.form.windowType == 30 || this.form.windowType == 21 || this.form.windowType == 23 || this.form.windowType == 26 || 
            this.form.windowType == 50 || this.form.WindowType == 55) {
          this.form.windowFb2 = 0;
          this.form.windowWeight2 = 1;
        }
        if (this.selectedHandle != null && this.selectedHandle.vrk != 1) this.form.handleReinforcement = 0;
        if (this.form.fcLockcase == 1) this.form.adjustableFCKeeps = 0;

        const editPayload = {
          Id: this.wid,
          ProjectId: this.proj.id,
          Name: this.form.windowName,
          Quantity: this.form.windowQuantity,
          Chrono: this.form.windowChrono,
          HingeType: this.form.windowHinge,
          HandleType: this.selectedHandle.vrk,
          OpenDir: Number(this.form.windowOpenDir),
          Fb1: this.form.windowFb1,
          Fb2: this.form.windowFb2,
          Fh: this.form.windowFh,
          A: this.form.windowA,
          RAB: this.form.windowRAB,
          MAC: this.form.windowMAC ? 1 : 0,
          K12: this.form.windowK12 ? 1 : 0,
          SNP: this.form.windowSNP ? 1 : 0,
          XVS: this.form.windowXVS ? 1 : 0,
          HandleAN: this.selectedHandle.anr,
          MotorAN: this.form.windowMotorAN,
          ColorCode: this.form.windowColor,
          WindowType: this.form.windowType,
          Weight1: this.form.windowWeight1,
          Weight2: this.form.windowWeight2,
          Groove: this.setgroove ? this.getgroove : Number(this.form.windowGroove),
          ScrewLength: this.setfcscrew ? this.getfcscrew : Number(this.form.windowScrew),
          ProfileDepth: this.setfcprofile ? this.getfcprofile : this.form.windowDepth,
          Bulk: this.setpackaging ? this.getpackaging : this.form.windowBulk ? 1 : 0,
          HandleSType: this.selectedHandle.sty != null ? this.selectedHandle.sty : 0,
          FCLockcase: this.isFCLockCaseAvailable ? (this.setfccentral ? this.getfccentral : this.form.fcLockcase ? 1 : 0) : 1,
          HandleReinforcement: this.sethandleplate ? this.gethandleplate : this.form.handleReinforcement ? 1 : 0,
          DrillingProtection: this.form.drillingProtection ? 1 : 0,
          AdjustableFCKeeps: this.setfcadjkeeps ? this.getfcadjkeeps : this.form.adjustableFCKeeps ? 1 : 0,
          Magnet: this.setfcmagnet ? this.getfcmagnet : this.form.magnet ? 1 : 0,
          Handle90Block: this.setblock90 ? this.getblock90 : this.form.handle90Block ? 1 : 0,
          Profile: this.form.profile
        };

        const createPayload = {
          ProjectId: this.proj.id,
          Name: this.form.windowName,
          Quantity: this.form.windowQuantity,
          Chrono: this.form.windowChrono,
          HingeType: this.form.windowHinge,
          HandleType: this.selectedHandle.vrk,
          OpenDir: Number(this.form.windowOpenDir),
          Fb1: this.form.windowFb1,
          Fb2: this.form.windowFb2,
          Fh: this.form.windowFh,
          A: this.form.windowA,
          RAB: this.form.windowRAB,
          MAC: this.form.windowMAC ? 1 : 0,
          K12: this.form.windowK12 ? 1 : 0,
          SNP: this.form.windowSNP ? 1 : 0,
          XVS: this.form.windowXVS ? 1 : 0,
          HandleAN: this.selectedHandle.anr,
          MotorAN: this.form.windowMotorAN,
          ColorCode: this.form.windowColor,
          WindowType: this.form.windowType,
          Weight1: this.form.windowWeight1,
          Weight2: this.form.windowWeight2,
          Groove: this.setgroove ? this.getgroove : Number(this.form.windowGroove),
          ScrewLength: this.setfcscrew ? this.getfcscrew : Number(this.form.windowScrew),
          ProfileDepth: this.setfcprofile ? this.getfcprofile : this.form.windowDepth,
          Bulk: this.setpackaging ? this.getpackaging : this.form.windowBulk ? 1 : 0,
          HandleSType: this.selectedHandle.sty != null ? this.selectedHandle.sty : 0,
          FCLockcase: this.isFCLockCaseAvailable ? (this.setfccentral ? this.getfccentral : this.form.fcLockcase ? 1 : 0) : 1,
          HandleReinforcement: this.sethandleplate ? this.gethandleplate : this.form.handleReinforcement ? 1 : 0,
          DrillingProtection: this.form.drillingProtection ? 1 : 0,
          AdjustableFCKeeps: this.setfcadjkeeps ? this.getfcadjkeeps : this.form.adjustableFCKeeps ? 1 : 0,
          Magnet: this.setfcmagnet ? this.getfcmagnet : this.form.magnet ? 1 : 0,
          Handle90Block: this.setblock90 ? this.getblock90 : this.form.handle90Block ? 1 : 0,
          Profile: this.form.profile
        };
        if (this.wid != 0) {
          this.windowedit(editPayload).then(() => {
            if (this.$store.state.windowCreateResponse.err == 0) {
              this.getwindows(this.proj.id);
              this.$router.go(-1);
            }
          })
        }
        if (this.wid == 0) {
          this.windowpost(createPayload).then(() => {
            if (this.$store.state.windowCreateResponse.err == 0) {
              this.getwindows(this.proj.id);
              this.$router.push("/projectwindows/" + this.proj.id);
            }
          });
        }
      },
      cancel() {
        this.$router.push("/projectwindows/" + this.proj.id);
      },
      caption(term) {
        var cpt = this.$store.getters.getTranslationByTerm(term);
        if(cpt === undefined)
        {
          return "";
        }

        return cpt.caption;
      },
      starttour: function () {
        this.$tours['WindowEditTour'].start()
      },
      myTourStart: function () {
        this.tour = true;
      },
      myTourStop: function () {
        this.tour = false;
      },
      changehinge: function () {
        this.form.windowRAB = 0;
        this.stay = this.caption("addwin_No");

        if(this.form.windowType == 50 || this.form.windowType == 55){
            if(this.invisitopprofiles.length > 0){
              if(this.invisitopprofiles.filter(x => x.prf == this.form.profile) == null)
              {
                this.form.profile = this.invisitopprofiles[0].prf;
              }
            }        
        } else {
          this.form.profile = "";
        }
      },
    }
  };
</script>

<style scoped>
  @media (min-width: 600px) {
    .container-fluid {
      width: 75%;
      font-size: 14px;
    }
  }

  @media (min-width: 1200px) {
    .container-fluid {
      width: 75%;
      font-size: 10px;
    }
  }

  @media (min-width: 2050px) {
    .container-fluid {
      width: 75%;
      font-size: 14px;
    }
  }

  .centered-and-cropped {
    object-fit: contain
  }
</style>



// WEBPACK FOOTER //
// src/components/windows/WindowEdit.vue